/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PortalLogin } from '../models/portal-login';
import { PortalLoginInput } from '../models/portal-login-input';

@Injectable({
  providedIn: 'root',
})
export class PortalLoginsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getSolidBriQPortalLogin
   */
  static readonly GetSolidBriQPortalLoginPath = '/api/v1/PortalLogins/SolidBriQ';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSolidBriQPortalLogin$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSolidBriQPortalLogin$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PortalLogin>> {

    const rb = new RequestBuilder(this.rootUrl, PortalLoginsService.GetSolidBriQPortalLoginPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PortalLogin>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSolidBriQPortalLogin$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSolidBriQPortalLogin$Plain(params?: {
  },
  context?: HttpContext

): Observable<PortalLogin> {

    return this.getSolidBriQPortalLogin$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<PortalLogin>) => r.body as PortalLogin)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSolidBriQPortalLogin()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSolidBriQPortalLogin$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PortalLogin>> {

    const rb = new RequestBuilder(this.rootUrl, PortalLoginsService.GetSolidBriQPortalLoginPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PortalLogin>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSolidBriQPortalLogin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSolidBriQPortalLogin(params?: {
  },
  context?: HttpContext

): Observable<PortalLogin> {

    return this.getSolidBriQPortalLogin$Response(params,context).pipe(
      map((r: StrictHttpResponse<PortalLogin>) => r.body as PortalLogin)
    );
  }

  /**
   * Path part for operation updateSolidBriQPortalLogin
   */
  static readonly UpdateSolidBriQPortalLoginPath = '/api/v1/PortalLogins/SolidBriQ';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSolidBriQPortalLogin$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSolidBriQPortalLogin$Plain$Response(params?: {
    body?: PortalLoginInput
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PortalLogin>> {

    const rb = new RequestBuilder(this.rootUrl, PortalLoginsService.UpdateSolidBriQPortalLoginPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PortalLogin>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSolidBriQPortalLogin$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSolidBriQPortalLogin$Plain(params?: {
    body?: PortalLoginInput
  },
  context?: HttpContext

): Observable<PortalLogin> {

    return this.updateSolidBriQPortalLogin$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<PortalLogin>) => r.body as PortalLogin)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSolidBriQPortalLogin()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSolidBriQPortalLogin$Response(params?: {
    body?: PortalLoginInput
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PortalLogin>> {

    const rb = new RequestBuilder(this.rootUrl, PortalLoginsService.UpdateSolidBriQPortalLoginPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PortalLogin>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSolidBriQPortalLogin$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSolidBriQPortalLogin(params?: {
    body?: PortalLoginInput
  },
  context?: HttpContext

): Observable<PortalLogin> {

    return this.updateSolidBriQPortalLogin$Response(params,context).pipe(
      map((r: StrictHttpResponse<PortalLogin>) => r.body as PortalLogin)
    );
  }

  /**
   * Path part for operation deleteSolidBriQPortalLogin
   */
  static readonly DeleteSolidBriQPortalLoginPath = '/api/v1/PortalLogins/SolidBriQ';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSolidBriQPortalLogin$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSolidBriQPortalLogin$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PortalLogin>> {

    const rb = new RequestBuilder(this.rootUrl, PortalLoginsService.DeleteSolidBriQPortalLoginPath, 'delete');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PortalLogin>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSolidBriQPortalLogin$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSolidBriQPortalLogin$Plain(params?: {
  },
  context?: HttpContext

): Observable<PortalLogin> {

    return this.deleteSolidBriQPortalLogin$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<PortalLogin>) => r.body as PortalLogin)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSolidBriQPortalLogin()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSolidBriQPortalLogin$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PortalLogin>> {

    const rb = new RequestBuilder(this.rootUrl, PortalLoginsService.DeleteSolidBriQPortalLoginPath, 'delete');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PortalLogin>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSolidBriQPortalLogin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSolidBriQPortalLogin(params?: {
  },
  context?: HttpContext

): Observable<PortalLogin> {

    return this.deleteSolidBriQPortalLogin$Response(params,context).pipe(
      map((r: StrictHttpResponse<PortalLogin>) => r.body as PortalLogin)
    );
  }

}
